import React, { useEffect, useState } from "react";
import "./Blogs.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedium } from "@fortawesome/free-brands-svg-icons";

const Events = () => {
  const [Blogs, setBlogs] = useState([]);
  document.title = `Blogs || Karan Kumar Agrawal`;


  useEffect(() => {
    const fetchMediumPosts = async () => {
      try {
        const rss_url = 'https://medium.com/feed/@karan25.pvt'; // Replace with your Medium handle
        const response = await fetch(
          `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rss_url)}`
        );
        const data = await response.json();
        console.log(data.items[0]);
        setBlogs(data.items); // Show latest 5 posts
      } catch (error) {
        console.error('Failed to fetch Medium posts:', error);
      }
    };

    fetchMediumPosts();
  }, []);

  function formatPubDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    // Get ordinal suffix
    const getOrdinalSuffix = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  }




  return (
    <div className="events-main">
      <h1 className="events-heading-text">My Blogs</h1>
      <div className="events-core" >
        <div className="events-cards-row">
          {Blogs.map((card, index) => (
            <div className="blogs-vertical-card" key={index}>
              {card.icon && (
                <div className="events-vertical-card-top">
                  <img
                    className="events-vertical-card-userimage"
                    src={card.icon}
                    alt=""
                  />
                </div>
              )}
              <div className="blogs-vertical-card-bottom">
                <h2 className="blogs-vertical-name-text">{card.title}</h2>
                <p className="blogs-vertical-name-desc">~ {card.author}</p>
                <p className="events-vertical-name-desc">{formatPubDate(card.pubDate)}</p>
              </div>
              <div className="events-buttons">

                {card.link && (
                  <a
                    href={card.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="blogs-button" type="button">
                      Read It On Medium <FontAwesomeIcon icon={faMedium} />
                    </button>
                  </a>
                )}

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
